import supportChatWidget from '@wix/support-chat-widget-wrapper';
import { ErrorReporter } from '../../errorHandling/ErrorReporter';
import { FedopsLoggerStore } from '../stores/FedopsLoggerStore';

const interactionName = 'embed-chat';

export async function initChatWidget({
  initFunc = supportChatWidget.init,
  errorReporter,
  fedopsLoggerStore,
}: {
  initFunc?: typeof supportChatWidget.init;
  errorReporter: ErrorReporter;
  fedopsLoggerStore: FedopsLoggerStore;
}): Promise<void> {
  try {
    fedopsLoggerStore.logger.interactionStarted(interactionName);
    await initFunc({ origin: 'TemplatesGallery' });
    fedopsLoggerStore.logger.interactionEnded(interactionName);
  } catch (error) {
    errorReporter.reportError(error);
  }
}
